import React, { useState } from "react";
import WhiteLogo from "../../assets/logo/black-logo.svg";
import DownIcon from "../../assets/icons/down-black.svg";
import SearchIcon from "../../assets/icons/black-search.svg";
import SearchIconMobile from "../../assets/icons/black-searcch-m.svg";
import MobileMenu from "../../assets/icons/black-mebnu.svg";
import "./blackHeader.scss";
import { NavLink } from "react-router-dom";
export default function BlackHeader() {
  const [headerOpen, setHeaderOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);

  return (
    <>
      <div className="black-header-alignment">
        <div className="header-alignment">
          <div className="logo">
            <NavLink to="/">
              <img src={WhiteLogo} alt="WhiteLogo" />
            </NavLink>
          </div>
          <div className="menu-search-alignment">
            <div className="menu">
              <div className="menu-relative">
                <a onClick={() => setDropdownOpen2(!dropdownOpen2)}>
                  <span>Immobilienvermittlung</span>
                  <img src={DownIcon} alt="DownIcon" />
                </a>
                <div
                  className={
                    dropdownOpen2
                      ? "relative-dropdown-design first-mobile-dropdown-show"
                      : "relative-dropdown-design first-mobile-dropdown-hidden"
                  }
                >
                  <div className="relative-dropdown-design-style">
                    <NavLink
                      to="/immobilienvermittlung"
                      onClick={() => setDropdownOpen2(false)}
                    >
                      <span>Erfolgsabhängig</span>
                    </NavLink>
                    <NavLink
                      to="/provisionsfrei-page"
                      onClick={() => setDropdownOpen2(false)}
                    >
                      <span>Provisionsfrei</span>
                    </NavLink>
                  </div>
                </div>
              </div>
              <NavLink to="/property-management">Property-Management</NavLink>
              <NavLink to="/lizenzpartner">Lizenzpartner</NavLink>
              <NavLink to="/kontakt-formular">Suchauftrag</NavLink>
            </div>
            <NavLink to="/kontakt">
              <div className="search-button">
                <button>Kontakt</button>
              </div>
            </NavLink>
            <div className="mobile-sidebar">
              <NavLink to="/kontakt">
                <img src={SearchIconMobile} alt="SearchIconMobile" />
              </NavLink>
            </div>
            <div
              className="mobile-sidebar"
              onClick={() => setHeaderOpen(!headerOpen)}
            >
              <img src={MobileMenu} alt="MobileMenu" />
            </div>
          </div>
        </div>
      </div>
      {headerOpen && <div className="header-wrapper"></div>}
      <div
        className={
          headerOpen
            ? "mobile-header-design mobile-header-design-show"
            : "mobile-header-design-hidden mobile-header-design"
        }
      >
        <div className="mobile-header-design-style">
          <div>
            <img src={WhiteLogo} alt="WhiteLogo" />
          </div>
          <div onClick={() => setHeaderOpen(false)}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div className="mobile-header-body">
          <div className="menu">
            <div className="mobile-first-menu-dropdown-alignment">
              <a
                className="web-primary-text-color"
                onClick={() => setDropdownOpen1(!dropdownOpen1)}
              >
                <span>Immobilienvermittlung</span>
                <img src={DownIcon} alt="DownIcon" />
              </a>
            </div>
            <div
              className={
                dropdownOpen1
                  ? "first-mobile-dropdown first-mobile-dropdown-show"
                  : "first-mobile-dropdown first-mobile-dropdown-hidden"
              }
            >
              <NavLink
                style={{ textDecoration: "none" }}
                onClick={() => {
                  setHeaderOpen(false);
                  setDropdownOpen1(!dropdownOpen1);
                }}
                to="/immobilienvermittlung"
              >
                <span>Erfolgsabhängig</span>
              </NavLink>
              <NavLink
                to="/provisionsfrei-page"
                onClick={() => {
                  setHeaderOpen(false);
                  setDropdownOpen1(!dropdownOpen1);
                }}
              >
                <span>Provisionsfrei</span>
              </NavLink>
            </div>

            <NavLink
              to="/property-management"
              onClick={() => setHeaderOpen(false)}
            >
              Property-Management
            </NavLink>
            <NavLink to="/lizenzpartner" onClick={() => setHeaderOpen(false)}>
              Lizenzpartner
            </NavLink>
            <NavLink
              to="/kontakt-formular"
              className="web-primary-text-color"
              onClick={() => setHeaderOpen(false)}
            >
              Suchauftrag
            </NavLink>

            <NavLink
              className="web-primary-text-color"
              onClick={() => setHeaderOpen(false)}
              to="/kontakt"
            >
              Kontakt
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
}
